import { lazy } from 'react';

import type { RouteConfig } from '../../types';

const DashboardLayout = lazy(() => import('@/layouts/DashboardLayout'));
const QcResponsesReportsLayout = lazy(() => import('@/pages/qcResponsesReports/layout'));
const QcResponsesReportsListPage = lazy(() => import('@/pages/qcResponsesReports'));

/**
 * UG-4504 review round — the aggregated `/qc-responses-reports` grid (legacy
 * `app/(dashboard)/qc-responses-reports/page.tsx`), unblocked by reipm-api's
 * new `getAllForReport`/`getTotalForReport` endpoints. Permission
 * (`qcResponse.view`) lives in `@/config/auth/routeAccess`, ported 1:1 from
 * the legacy table. Legacy also listed a `/qc-responses-reports/[qcId]/view`
 * access rule but never shipped such a page (rows link to `/jobs/:id/view`) —
 * no view route here either.
 */
export const qcResponsesReportRoutes: RouteConfig = {
  path: '/qc-responses-reports',
  layout: DashboardLayout,
  children: [
    {
      path: '',
      layout: QcResponsesReportsLayout,
      children: [{ path: '', element: QcResponsesReportsListPage }],
    },
  ],
};
